import {Status} from '@cypro/ui/components/ui/status'
import {Box, Listbox, Text} from '@chakra-ui/react'
import {ReactNode} from 'react'

interface Props extends Listbox.ItemProps {
  label: string
  description: ReactNode
  status: string | null
}

export function ResourceListboxItem({label, description, status, ...props}: Props) {
  return (
    <Listbox.Item display="flex" alignItems="center" justifyContent="space-between" gapX="2" {...props}>
      <Status value={status === 'active' ? 'success' : 'error'} />

      <Box width="100%">
        <Listbox.ItemText fontWeight="medium">{label}</Listbox.ItemText>
        <Text fontSize="xs" color="fg.muted">
          {description}
        </Text>
      </Box>

      <Listbox.ItemIndicator />
    </Listbox.Item>
  )
}
